export function numberToFixed(value: number | undefined, maxNoOfDecimals: number = 2) {
  return value != null
    ? value.toLocaleString("en", {
        maximumFractionDigits: maxNoOfDecimals,
        useGrouping: false,
      })
    : "N/A";
}
